import React, { useEffect, useRef, useState } from "react";

function AboutDescription({ data }) {
  const rawText = data;

  // convert block tags → inline so they don't break lines
  const cleanedHTML = rawText
    .replaceAll("<p", "<span")
    .replaceAll("</p>", "</span>")
    .replaceAll("<div", "<span")
    .replaceAll("</div>", "</span>");

  const [clampedHTML, setClampedHTML] = useState("");
  const [needsClamp, setNeedsClamp] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const measureRef = useRef(null);

  const clampText = () => {
    const el = measureRef.current;
    if (!el) return;

    el.innerHTML = cleanedHTML;

    const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
    const maxHeight = lineHeight * 3;

    if (el.scrollHeight <= maxHeight) {
      setNeedsClamp(false);
      setClampedHTML(cleanedHTML);
      return;
    }

    setNeedsClamp(true);

    let low = 0;
    let high = cleanedHTML.length;
    let best = cleanedHTML;

    while (low <= high) {
      const mid = Math.floor((low + high) / 2);
      el.innerHTML = cleanedHTML.slice(0, mid);

      if (el.scrollHeight <= maxHeight) {
        best = cleanedHTML.slice(0, mid);
        low = mid + 1;
      } else {
        high = mid - 1;
      }
    }

    best = best.replace(/\s+\S*$/, "");
    setClampedHTML(best);
  };

  useEffect(() => {
    setTimeout(() => clampText(), 10);
  }, [cleanedHTML]);

  return (
    <div className="position-relative">
      {/* Hidden measurement element */}
      <div
        ref={measureRef}
        style={{
          position: "absolute",
          visibility: "hidden",
          width: "100%",
          pointerEvents: "none",
          whiteSpace: "normal",
        }}
      />

      {/* Inline description */}
      <div style={{ display: "inline" }}>
        {!expanded ? (
          <>
            {/* INLINE HTML — no block tags anymore */}
            <span
              className="ckeditor tinymce-reset about-description fontSize-14"
              dangerouslySetInnerHTML={{ __html: clampedHTML }}
              style={{ display: "inline" }}
            />

            {needsClamp && (
              <span
                onClick={() => setExpanded(true)}
                className="read-more-hover ms-2"
              >
                ...more
              </span>
            )}
          </>
        ) : (
          <>
            <span
              className="ckeditor tinymce-reset about-description fontSize-14"
              dangerouslySetInnerHTML={{ __html: rawText }}
              style={{ display: "inline" }}
            />

            {/* <span
              onClick={() => setExpanded(false)}
              style={{
                color: "var(--portal-primary-color)",
                cursor: "pointer",
                marginLeft: "5px",
              }}
            >
              view less
            </span> */}
          </>
        )}
      </div>
    </div>
  );
}

export default AboutDescription;
